import { createContext, type RefObject, useContext } from "react";

const OverlayPortalContainerContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

export const OverlayPortalContainerProvider =
  OverlayPortalContainerContext.Provider;

/** Portal target for floating UI inside React Aria modals (avoids inert/pointer blocking on `body`). */
export const useOverlayPortalContainer = () =>
  useContext(OverlayPortalContainerContext);
